<!-- @format -->

<template>
	<div style="width: 100%">
		<disabled-text v-if="disabled && pcProps.showDisabledText" :value="showValue" :show-tag="true" />
		<el-input
			v-else
			:model-value="showValue"
			placeholder="请选择组"
			:disabled="disabled"
			clearable
			suffix-icon="ArrowDown"
			@click="onShowUser()"
			@clear="() => onConfirm('clear')"
		/>
		<pcp-group-selector-dialog
			:value="value"
			:multiple="multiple"
			:visible="selectorVisible"
			@close="(visible) => (selectorVisible = visible)"
			@action-event="onConfirm"
		/>
	</div>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';
	import type { BasicField, WidgetConfigType } from '../../types';
	import { PcpGroupSelectorDialog } from '@/p-components';

	interface Props {
		modelValue: any;
		pcProps: WidgetConfigType;
		disabled?: boolean;
		item: BasicField;
		multiple?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const selectorVisible = ref(false);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const showValue = computed(() => {
		return value.value.map((item) => item.name).join(',');
	});

	const onShowUser = () => {
		if (props.pcProps.isRequired !== '0') {
			selectorVisible.value = true;
		}
	};

	const onConfirm = (key, data?) => {
		if (key == 'confirm') {
			selectorVisible.value = false;
			const list: any[] = [];

			if (Array.isArray(data)) {
				data.forEach((item) => {
					const index = value.value.find((d) => d.id === item.id);
					if (!index) {
						list.push(item);
					}
				});
				value.value = value.value.concat(list);
			}
		} else if (key == 'clear') {
			value.value = [];
		}
	};
</script>

<style lang="scss" scoped></style>
